import { combineReducers } from 'redux';
import groupShow from './groupShow';

const pigGroupsReducer = combineReducers({
  groupShow,
});

export default pigGroupsReducer;
